import { getFirestore, doc, collection, query, where, addDoc, getDoc, getDocs, updateDoc, setDoc, onSnapshot, deleteDoc, documentId } from "firebase/firestore"

let db = getFirestore()
let collectionName = 'applications/'

function docToInstance(document) {
  let data = document.data()
  return !data || data.type !== 'app_valy' ? null : new Application(document.id, data.organisation, data.name, data.type, data.archived, data.users, data.autoArchivingDate)
}
export default class Application {
  constructor(id, organisation, name, type, archived, users, autoArchivingDate) {
    this.id = id
    this.organisation = organisation
    this.name = name
    this.type = type
    this.archived = archived
    this.users = users
    this.autoArchivingDate = autoArchivingDate
  }

  static listenById(orgaId, callback) {
    return onSnapshot(doc(db, collectionName, orgaId), snapshot => {
      callback(docToInstance(snapshot))
    })
  }

  static listenAll(callback) {
    let docQuery = query(collection(db, collectionName), where('type', '==', 'app_valy'))

    return onSnapshot(docQuery, snapshot => {
      callback(snapshot.docs.map(docToInstance))
    })
  }

  static listenNotArchivedByProfile(profile, callback) {
    let docQuery

    if (profile.role === 'SuperAdmin') {
      docQuery = query(collection(db, collectionName),
        where('archived', '==', false),
        where('type', '==', 'app_valy')
      )
    } else {
      docQuery = query(collection(db, collectionName),
        where('users', 'array-contains', profile.id),
        where('archived', '==', false),
        where('type', '==', 'app_valy')
      )
    }

    return onSnapshot(docQuery, snapshot => {
      callback(snapshot.docs.map(docToInstance))
    })
  }

  static async getAll(){
    let documents = await getDocs(collection(db, collectionName))
    let res = documents.docs.map(docToInstance)
    res = res.filter(app => (app && app.type == "app_valy"))
    return res
  }
}
